import { editorConfig } from '~config';
import { getStatePure } from '~src/state';
import { v4 as uuidv4 } from 'uuid';

const getCanvasJson = (copyCurrentPage = true) => {
  if (
    window.canvas?.toJSON &&
    typeof window.canvas.toJSON === 'function' &&
    copyCurrentPage
  ) {
    return window.canvas.toJSON(editorConfig.additionalJsonProperties);
  } else {
    return {
      background: '#ffffff',
    };
  }
};

export const createEmptyPage = (copyCurrentPage = true) => {
  const pages = getStatePure('pages');
  const currentPageIndex = getStatePure('currentPageIndex');

  // Niente imgData: la pagina nuova viene aperta subito (addPage) e la sua
  // immagine di stampa si genera quando serve.
  let newPage;
  if (
    pages &&
    pages.length &&
    typeof currentPageIndex !== 'undefined' &&
    pages[currentPageIndex] &&
    pages[currentPageIndex].preview
  ) {
    newPage = {
      temporaryId: uuidv4(),
      pageNumber: pages.length + 1,
      canvasJson: JSON.stringify(getCanvasJson(copyCurrentPage)),
      preview: pages[currentPageIndex].preview,
      order: pages.length + 1,
    };
  } else {
    newPage = {
      temporaryId: uuidv4(),
      pageNumber: 1,
      canvasJson: JSON.stringify(getCanvasJson(copyCurrentPage)),
      order: 0,
    };
  }

  return newPage;
};
